import React, {useEffect} from "react";
import {Badge} from "antd";
import {useDispatch} from "react-redux";
import {userAC} from "../../../store/branches/user/actionCreators";
import {useHistory} from "react-router-dom";

import {ReactComponent as HeaderNotification} from "../../../assets/icons/header_notification.svg";

import classes from "../Header.module.scss";

interface NotifyProps {
    messageCount?: number
    openNotification?: () => void
    wsNotification?: any
}

const Notify: React.FC<NotifyProps> = ({
                                           messageCount,
                                           openNotification,
                                           wsNotification,
                                       }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    useEffect(() => {
        wsNotification && openNotification();
    }, [openNotification, wsNotification]);

    const handleClick = () => {
        dispatch(userAC.setNotificationsFilter(true)); // Set to active notifications
        history.push(`/notifications/all?timestamp=${Date.now()}`);
    };

    return (
        <React.Fragment>
            <div onClick={handleClick}>
                <Badge overflowCount={999} count={messageCount}>
                    <HeaderNotification className={classes.headerNotify}/>
                </Badge>
            </div>
        </React.Fragment>
    );
};

export default Notify;
